









































































































import Vue from "vue";
import { authentication } from "@/stores";
import { Route } from "vue-router";
import { Lottery } from "@/models";
import { firestore } from "firebase/app";
import firebaseProject from "@/common/firebaseProject";
import { Collection, Document, List, DocDataRef } from "@/stores";
import { form, autoclose, shopBase } from "@/mixins";
import { alert, confirm } from "@/services/dialog";
import { Loading } from "@/stores";

const db = firebaseProject.firestore();
const functions = firebaseProject.functions("asia-northeast1");

export default shopBase.extend(Vue).extend({
  name: "ShopLotteryLotteryList",
  mixins: [],
  data(): {
    authentication: object;
    loading: Loading;
    parPage: number;
    currentPage: number;
  } {
    return {
      authentication,
      loading: new Loading(),
      parPage: 10,
      currentPage: 1
    };
  },
  async created() {
    if (this.$route.query.currentPage) {
      this.currentPage = Number(this.$route.query.currentPage);
    }
  },
  computed: {
    lotterys(): List<Lottery> {
      const path = `/lottery`;
      return new Collection(
        db.collection(path) as firestore.CollectionReference<Lottery>
      ).query({
        filter: {
          shopId: { $eq: this.shopId }
        },
        orderBy: {
          field: "createTime",
          order: "desc"
        }
      });
    },
    listItem(): DocDataRef<Lottery>[] | [] {
      const current = this.currentPage * this.parPage;
      const start = current - this.parPage;
      return this.lotterys?.items
        ? this.lotterys.items.slice(start, current)
        : [];
    },
    getPageCount(): number {
      return this.lotterys?.items
        ? Math.ceil(this.lotterys.items.length / this.parPage)
        : 0;
    },
    total(): number {
      return this.lotterys.items?.length || 0;
    },
    pageMax(): number {
      const count = this.currentPage * this.parPage;
      const total = this.total || 0;
      return total < count ? total : count;
    }
  },
  methods: {
    clickPaginate(pageNum: number) {
      this.currentPage = Number(pageNum);
    },
    async startPublish(lotteryId: string) {
      if (!lotteryId) {
        return;
      }
      const confirmed = await confirm({
        title: "確認",
        text: `配信再開します。よろしいですか？`
      });
      if (confirmed === true) {
        await db.doc(`/lottery/${lotteryId}`).update({
          stopPublish: 0
        });
        // 一覧表示の変更
        this.$router.push({
          path:
            "/shoplottery/lottery?currentPage=" +
            this.currentPage +
            "&t=" +
            Date.now()
        });
      }
    },
    async stopPublish(lotteryId: string) {
      if (!lotteryId) {
        return;
      }
      const confirmed = await confirm({
        title: "確認",
        text: `配信終了します。よろしいですか？`
      });
      if (confirmed === true) {
        await db.doc(`/lottery/${lotteryId}`).update({
          stopPublish: 1
        });
        // 一覧表示の変更
        this.$router.push({
          path:
            "/shoplottery/lottery?currentPage=" +
            this.currentPage +
            "&t=" +
            Date.now()
        });
      }
    },
    async downloadErrorCsv(lotteryId: string) {
      if (!lotteryId) {
        return;
      }
      this.loading.run(async () => {
        const params = {
          lotteryId: lotteryId
        };
        const callable = functions.httpsCallable(
          "consoleLotteryDownloadErrorCsv"
        );
        const result = await callable(params)
          .then(res => {
            console.log(res);
            if (res && res.data.status == "SUCCEED") {
              const csv = res.data.csv;
              location.href = csv;
            } else {
              alert({
                title: "エラー",
                text: "ダウンロードに失敗しました。"
              });
            }
          })
          .catch(e => {
            console.error(e);
            alert({
              title: "エラー",
              text: "ダウンロードに失敗しました。"
            });
          });
      });
    }
  },
  watch: {
    $route() {
      location.reload();
    }
  }
});
